
import { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { RouteProps } from "@/types/routes";
import Index from "@/pages/Index";
import Meals from "@/pages/Meals";
import MealDetails from "@/pages/MealDetails";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import CookProfile from "@/pages/CookProfile";
import Map from "@/pages/Map";
import Review from "@/pages/Review";
import Favorites from "@/pages/Favorites";
import Inbox from "@/pages/Inbox";
import Conversation from "@/pages/Conversation";
import Profile from "@/pages/Profile";
import { AuthProtectedRoute } from "@/components/auth/AuthProtectedRoute";

export const mainRoutes = ({ session }: RouteProps): RouteObject[] => [
  {
    path: "/",
    element: <Index />
  },
  {
    path: "/meals",
    element: <Meals />
  },
  {
    path: "/meals/:mealId",
    element: <MealDetails />
  },
  {
    path: "/meal/:mealId",
    element: <MealDetails />
  },
  {
    path: "/cart",
    element: <AuthProtectedRoute><Cart /></AuthProtectedRoute>
  },
  {
    path: "/checkout",
    element: <AuthProtectedRoute><Checkout /></AuthProtectedRoute>
  },
  {
    path: "/order-confirmation",
    element: <AuthProtectedRoute><OrderConfirmation /></AuthProtectedRoute>
  },
  {
    path: "/cook/:id",
    element: <CookProfile />
  },
  {
    path: "/map",
    element: <Map />
  },
  {
    path: "/review/:orderId",
    element: <AuthProtectedRoute><Review /></AuthProtectedRoute>
  },
  {
    path: "/favorites",
    element: <AuthProtectedRoute><Favorites /></AuthProtectedRoute>
  },
  {
    path: "/inbox",
    element: <AuthProtectedRoute><Inbox /></AuthProtectedRoute>
  },
  {
    path: "/inbox/:conversationId",
    element: <AuthProtectedRoute><Conversation /></AuthProtectedRoute>
  },
  {
    path: "/profile",
    element: <AuthProtectedRoute><Profile /></AuthProtectedRoute>
  }
];
